import { currencyRepository } from '@webapp/core/data-access/repositories/CurrencyRepository'
import { expenseRepository } from '@webapp/modules/expense/data-access/repositories/ExpenseRepository'
import { GetMileageLockSettingUseCase } from './GetMileageLockSettingUseCase'

export const getMileageLockSettingUseCase = new GetMileageLockSettingUseCase({
  expenseRepository,
  currencyRepository,
})

export { GetMileageLockSettingUseCase } from './GetMileageLockSettingUseCase'
